<template>
    <b-modal :title="Core.Definition.getDefinition('Connexion API')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                :ignoreRouteParamId="ignoreRouteParamId"
                @onSave="onSave"
                @onTrashClick="onTrashClick"
                @onRequestSuccess="onRequestSuccess"
                ref="dynamicForm"
                :options="{
                    submit: {
                        text: 'Créer',
                        variant: 'success'
                    }
                }"
                :getRoot="options.root.get"
                :saveRoot="options.root.save"
                :trashRoot="options.root.trash"
                :formStructure="dataFormStructures.api">
        </DynamicForm>
    </b-modal>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from './DynamicForm'
    import Alert from './Alert'
    export default {
        name: 'ModalAPI',
        components: {
            DynamicForm
        },
        props: {
            ignoreRouteParamId: {
                type: Boolean,
                default: false
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            save: '/api',
                            get: '/api',
                            trash: '/api'
                        }
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSaveAddArgs: [],
                dataShow: false,
                dataFormStructures: {
                    api: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'name'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'domain'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'name',
                                type: 'text',
                                label: Core.Definition.getDefinition('Nom'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'domain',
                                type: 'text',
                                label: Core.Definition.getDefinition('Domaine'),
                                value: '',
                                required: true
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            addSaveArg(key, value, type) {
                this.dataSaveAddArgs.push({
                    key: key,
                    value: value,
                    type: type
                })
            },
            onSave() {
                for(let saveAddArg in this.dataSaveAddArgs) {
                    saveAddArg = this.dataSaveAddArgs[saveAddArg]
                    this.$refs.dynamicForm.addSaveArg(saveAddArg.key, saveAddArg.value, saveAddArg.type)
                }
            },
            onTrashClick(id) {
                this.$refs.dynamicForm.trash()
            },
            onRequestSuccess(data, method) {
                switch (method) {
                    case Core.Request.methodGet:
                        break
                    case Core.Request.methodPost:
                    case Core.Request.methodPut:
                        this.$emit('onSave', data, this.$refs.dynamicForm.$refs.form.fieldRefs)
                        this.open = false
                        break
                    case Core.Request.methodDelete:
                        this.$emit('onTrash', data, this.$refs.dynamicForm.$refs.form.fieldRefs)
                        this.open = false
                        break
                }
            }
        }
    }
</script>
